import { render, staticRenderFns } from "./bloqueos.vue?vue&type=template&id=89914760&"
import script from "./bloqueos.vue?vue&type=script&lang=js&"
export * from "./bloqueos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports